import {NgModule, NO_ERRORS_SCHEMA} from "@angular/core";
import {SvgIconsDefinitionsComponent} from "./components/svg.icons.definitions/svg.icons.definitions.component";
import {SvgIconComponent} from "./components/svg.icon/svg.icon.component";
//import {SvgIconsProvidersModule} from "./svg.icons.providers.module";
import {CommonModule} from "@angular/common";
import {ButtonModule} from "../button/button.module";
import {SvgIconDefinitionComponent} from "./components/svg.icon.definition/svg.icon.definition.component";

@NgModule({
	declarations: [
		SvgIconsDefinitionsComponent,
		SvgIconComponent,
		SvgIconDefinitionComponent
	],
	exports: [
		SvgIconsDefinitionsComponent,
		SvgIconComponent,
		SvgIconDefinitionComponent
	],
	schemas: [
		NO_ERRORS_SCHEMA
	],
	imports: [
		CommonModule,
		//SvgIconsProvidersModule,
		ButtonModule
	]
})
export class SvgIconsModule { }
